var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeFeedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42467 17.2214C7.26634 17.2214 7.10801 17.163 6.98301 17.038C6.74134 16.7964 6.74134 16.3964 6.98301 16.1547L12.4163 10.7214C12.8163 10.3214 12.8163 9.67135 12.4163 9.27135L6.98301 3.83802C6.74134 3.59635 6.74134 3.19635 6.98301 2.95469C7.22467 2.71302 7.62467 2.71302 7.86634 2.95469L13.2997 8.38802C13.7247 8.81302 13.9663 9.38802 13.9663 9.99636C13.9663 10.6047 13.733 11.1797 13.2997 11.6047L7.86634 17.038C7.74134 17.1547 7.58301 17.2214 7.42467 17.2214Z",
    fill: "#D77910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeFeedIcon);
export default __webpack_public_path__ + "static/media/orangeFeedIcon.b009209f4382c199ed226ff02068ef9c.svg";
export { ForwardRef as ReactComponent };